import React from 'react';
import { NumericFormat } from 'react-number-format';
import { FormControl, Box, FormHelperText, TextField } from '@mui/material';

export default function DealMarketMedianPropertyValueField({
  value,
  error,
  setValue,
  setError,
}) {
  const handleChange = (values) => {
    setValue(values.floatValue);
  };
  return (
    <Box>
      <FormControl fullWidth>
        <NumericFormat
          value={value}
          prefix='$'
          onValueChange={handleChange}
          customInput={TextField}
          aria-describedby='market-median-property-value-helper-text'
          label='Median Property Value'
          id='market_median_property_value'
          error={Boolean(error)}
          variant='standard'
          thousandSeparator=','
        />

        {error ? (
          <FormHelperText id='market-median-property-value-helper-text'>
            {error}
          </FormHelperText>
        ) : (
          <FormHelperText id='market-median-property-value-helper-text'>
            Enter the median property value of the market.
          </FormHelperText>
        )}
      </FormControl>
    </Box>
  );
}
